import { CSSProperties } from "react";
import { ActionSlot } from "~/business";
import { XActionSlot, XPackBy } from "~/jsx/components/design";
import { useActions } from "~/jsx/hook";
import { Spacing } from "~/jsx/theme";
import { XActionSlotSection } from "./XActionSlotSection";
import { useGame } from "~/app";

const actionSlotGap = Spacing.actions;

export const XActionSlotGroup = ({
  groupBy,
  style,
  actionSlots: selectedSlots,
}: {
  groupBy?: number;
  style?: CSSProperties;
  actionSlots: ActionSlot[];
}) => {
  const { game } = useGame();
  const { onActionSlotClickFactory } = useActions();

  return (
    <XActionSlotSection agentIcon={selectedSlots[0].agentIcon} style={style}>
      <XPackBy packSize={groupBy ?? selectedSlots.length} gap={actionSlotGap}>
        {selectedSlots.map((actionSlot, index) => (
          <XActionSlot
            key={index}
            actionSlot={actionSlot}
            onClick={onActionSlotClickFactory(actionSlot)}
            mentatOpt={game.mentatOnSlotOpt}
            allowOverlay={true}
            noShadow={true}
          />
        ))}
      </XPackBy>
    </XActionSlotSection>
  );
};
